import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import './App.css';

import Audit from "./components/Audit";
import Header from "./components/Header";
import Login from "./components/Login";
import NoMatch from "./components/NoMatch";
import Venue from "./components/Venue";
import VenueList from "./components/VenueList";

var axios = require('axios');

class App extends Component
{
	constructor(props)
	{
		super(props);

		this.timer = 0;

		this.state = {
			auth: {
				token: localStorage.getItem("auth-token"),
				expires: localStorage.getItem("auth-expires")
			},
			filters: {
				venues: {
					name: "",
					area: process.env.REACT_APP_DEFAULTS_FILTERS_VENUES_AREA,
					quantity: process.env.REACT_APP_DEFAULTS_FILTERS_VENUES_QUANTITY,
					page: 0,
					mood: false,
					recommended: false
				},
				audit: {
				}
			}
		};
	}
	componentWillMount()
	{
		// set up timer
		this.timer = setTimeout(() => {
			if (new Date().getTime() > new Date(this.state.auth.expires))
			{
				this.clearAuth();
			}

			this.componentWillMount();
		}, Math.floor(Date.now() / 1000) * 1000 + 1000 - Date.now());
	}
	componentWillUnmount()
	{
		// remove timer
		clearTimeout(this.timer);
	}
	updateFilter = (type, field, value) => {
		let newState = {...this.state};
		newState.filters[type][field] = value;

		this.setState(newState);
	}
	getVenues = (range, parameters) => {
		return new Promise((fulfil, reject) => {
			let config = {
				headers: {
					"Range": "indices=" + range.start + "-" + range.end,
					"Content-Type": "application/json",
					"Authorization": "Local " + this.state.auth.token
				}
			};

			axios.post(process.env.REACT_APP_API_ROOT + "venues/search/", parameters, config)
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	getVenue = (id) => {
		return new Promise((fulfil, reject) => {
			axios.get(process.env.REACT_APP_API_ROOT + "venues/" + id + "/")
				.then(fulfil)
				.catch(reject);
		});
	}
	addVenue = (parameters) => {

		let config = {
			headers: {
				"Authorization": "Local " + this.state.auth.token
			}
		};

		parameters.feed = "Custom";
		parameters.options.active = true;

		return new Promise((fulfil, reject) => {
			axios.post(process.env.REACT_APP_API_ROOT + "venues/", parameters, config)
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	triggerProcessing = (id, type) => {

		let config = {
			headers: {
				"Authorization": "Local " + this.state.auth.token
			}
		};

		let parameters = {
			action: type
		}

		return new Promise((fulfil, reject) => {
			axios.post(process.env.REACT_APP_API_ROOT + "venues/" + id + "/trigger/", parameters, config)
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	getPhotos = (id) => {
		return new Promise((fulfil, reject) => {
			axios.get(process.env.REACT_APP_API_ROOT + "venues/" + id + "/photos/")
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	uploadPhoto = (parameters) => {

		let venueId = parameters.get("id");

		let config = {
			headers: {
				"Authorization": "Local " + this.state.auth.token
			}
		};

		return new Promise((fulfil, reject) => {
			axios.post(process.env.REACT_APP_API_ROOT + "venues/" + venueId + "/photos/", parameters, config)
				.then(response => {
					this.getPhotos(venueId)
						.then(fulfil)
						.catch(reject);
				})
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	updatePhoto = (parameters) => {

		let config = {
			headers: {
				"Authorization": "Local " + this.state.auth.token
			}
		};

		return new Promise((fulfil, reject) => {
			axios.patch(process.env.REACT_APP_API_ROOT + "photos/" + parameters.id + "/", parameters, config)
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	deletePhoto = (id) => {

		let config = {
			headers: {
				"Authorization": "Local " + this.state.auth.token
			}
		};

		return new Promise((fulfil, reject) => {
			axios.delete(process.env.REACT_APP_API_ROOT + "photos/" + id + "/", config)
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	updateVenue = (parameters) => {
		let config = {
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Local " + this.state.auth.token
			}
		};

		if (parameters.options.rating === true)
		{
			parameters.rating = parameters.override;
			delete parameters.override;
		}

		return new Promise((fulfil, reject) => {
			axios.patch(process.env.REACT_APP_API_ROOT + "venues/" + parameters.id + "/", parameters, config)
				.then(fulfil)
				.catch(response => {
					this.handleApiResponse(response);
					reject(response);
				});
		});
	}
	authenticate = (username, password) => {
		let config = {
			headers: {
				"Content-Type": "application/json"
			}
		};

		let parameters = {
			username: username,
			password: password
		};

		return new Promise((fulfil, reject) => {
			axios.post(process.env.REACT_APP_API_ROOT + "authentication/", parameters, config)
				.then(fulfil)
				.catch(error => {
					let message = (error.response.data["client error"].data) ? error.response.data["client error"].data : error.response.data["client error"].message;

					alert(message);
					reject(error);
				});
		});
	}
	logout = () => {
		this.setState({auth: {token: null, expires: 0}});
		localStorage.removeItem("auth-token");
		localStorage.removeItem("auth-expires");
	}
	setAuth = (token, expires) => {
		let auth = {
			token: token,
			expires: expires
		};

		this.setState({auth: auth});
		localStorage.setItem("auth-token", token);
		localStorage.setItem("auth-expires", expires);
	}
	clearAuth = () => {
		this.setState({auth: {token: null, expires: 0}});

		localStorage.removeItem("auth-token");
		localStorage.removeItem("auth-expires");
	}
	// Todo: move into utils library/file
	parseRange = (header) => {
		return parseInt(header.split("/")[1], 10);
	}
	handleApiResponse = (data) => {
		// Auto logout
		if (data.response.status === 401 || data.response.status === 419)
		{
			this.logout();
		}
	}
	render()
	{
		if (!this.state.auth.token)
		{
			return (
				<Login authenticate={this.authenticate} setAuth={this.setAuth} />
			);
		}
		else
		{
			return (
				<Router>
					<div className="App">
						<Header />

						<main>
							<Switch>
								<Route exact path="/" render={() => (<Redirect to="/venues"/>)} />
								<Route exact path="/venues" render={(routeProps) => (
									<VenueList {...routeProps}
										filters={this.state.filters.venues}
										getVenues={this.getVenues}
										parseRange={this.parseRange}
										updateFilter={this.updateFilter}
									/>
								)} />
								<Route path="/venues/:id/" render={(routeProps) => (
									<Venue {...routeProps}
										getVenue={this.getVenue}
									    addVenue={this.addVenue}
									    updateVenue={this.updateVenue}
									    getPhotos={this.getPhotos}
									    uploadPhoto={this.uploadPhoto}
									    updatePhoto={this.updatePhoto}
									    deletePhoto={this.deletePhoto}
									    triggerProcessing={this.triggerProcessing}
									/>
								)} />
								<Route path="/audit" component={Audit} />
								<Route component={NoMatch} />
							</Switch>
						</main>

						<footer>

						</footer>
					</div>
				</Router>
			);
		}
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js